import {FC, useState} from 'react'
import {MailingContext} from '../../../@types'

const MailingProvider: FC = ({children}) => {

  const [reloadKey, setReloadKey] = useState<number>(0)

  const triggerReload = () => setReloadKey(prevKey => prevKey + 1)

  return (
    <MailingContext.Provider value={{reloadKey, triggerReload}}>
      {children}
    </MailingContext.Provider>
  )
}

export {MailingProvider}